export default __webpack_public_path__ + "static/media/adaComplianceImg.4c1bd284.jpg";